module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-images-wrapper"
  }, [_c('div', {
    staticClass: "zoom-parent"
  }, [(_vm.videoUrl && _vm.isVideoActive === 1 && (_vm.currImage === _vm.videoIndex - 1 || _vm.videoIndex === 0)) ? _c('div', {
    staticClass: "video-show"
  }, [_c('VideoPlayer', {
    attrs: {
      "src": _vm.videoUrl,
      "poster": _vm.getActiveImage,
      "playVideo": _vm.playVideo
    }
  })], 1) : _c('div', {
    staticClass: "productZoomer"
  }, [_c('img', {
    class: [{
      'show-blur': _vm.isBlur
    }],
    attrs: {
      "src": _vm.getActiveImage
    },
    on: {
      "click": function($event) {
        _vm.callMagnify(_vm.getActiveImage)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-list-wrap d-flex flex-row"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "bannerview",
    attrs: {
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "paginationPadding": 7,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 5],
        [1920, 6]
      ],
      "perPage": 3.2,
      "navigateTo": _vm.navShown ? _vm.getcurrPage : 0
    }
  }, _vm._l((_vm.getImageArray), function(prm, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "card-container pointer'"
    }, [_c('img', {
      staticClass: "img-card",
      attrs: {
        "data-src": prm
      },
      on: {
        "click": function($event) {
          _vm.switchImage(index)
        }
      }
    }), _vm._v(" "), (_vm.videoUrl && _vm.isVideoActive === 1 && (index === _vm.videoIndex - 1 || _vm.videoIndex === 0)) ? _c('div', {
      staticClass: "overlay",
      on: {
        "click": function($event) {
          _vm.switchImage(index)
        }
      }
    }, [_c('img', {
      class: [{
        'show-blur': _vm.isBlur
      }],
      staticStyle: {
        "height": "20px"
      },
      attrs: {
        "src": "https://tss-static-images.gumlet.io/media/play.png"
      }
    })]) : _vm._e()])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fa1e72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ProductBanner.vue
// module id = 2526
// module chunks = 14